module.exports = __webpack_public_path__ + "static/media/complete.ffeda0e6.svg";